export default "__VITE_ASSET__24628700__"